import type { Lang } from "@/i18n/languages";

export const SITE_NAME = "AllChinaBuy Spreadsheet";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg";

export const HOME_OG_IMAGE =
  "https://readdy.ai/api/search-image?query=Warm%20fashion%20flat%20lay%20overhead%20photography%20of%20luxury%20streetwear%20clothing%20spread%20out%20on%20a%20soft%20beige%20linen%20background%20with%20sneakers%20hoodies%20t-shirts%20watches%20and%20accessories%20arranged%20artistically%20warm%20natural%20light%20editorial%20style%20muted%20earth%20tones%20no%20text&width=1600&height=900&seq=hero-bg-2026-01&orientation=landscape";

export function getSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL;
  if (fromEnv) {
    return fromEnv.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }
  return "";
}

export interface HomeSeo {
  title: string;
  description: string;
  keywords: string;
}

export const HOME_SEO: Record<Lang, HomeSeo> = {
  en: {
    title: "AllChinaBuy Spreadsheet: Products, Sellers, QC & Shipping Guides",
    description:
      "Explore AllChinaBuy spreadsheet resources, product finds, seller guides, QC information, shipping costs, warehouse guides and practical buying advice — organized in one independent resource hub.",
    keywords:
      "AllChinaBuy spreadsheet, AllChinaBuy review, AllChinaBuy shipping cost, AllChinaBuy coupon, AllChinaBuy discount code",
  },
  fr: {
    title: "AllChinaBuy Spreadsheet : produits, vendeurs, QC et guides d'expédition",
    description:
      "Explorez les ressources du spreadsheet AllChinaBuy, les trouvailles de produits, les guides de vendeurs, les informations QC, les frais d'expédition et les conseils d'achat — réunis dans un hub indépendant.",
    keywords:
      "AllChinaBuy spreadsheet, AllChinaBuy avis, AllChinaBuy frais de livraison, AllChinaBuy coupon, AllChinaBuy code promo",
  },
  da: {
    title: "AllChinaBuy Spreadsheet: produkter, sælgere, QC og forsendelsesguider",
    description:
      "Udforsk AllChinaBuy spreadsheet-ressourcer, produktfund, sælgerguider, QC-information, forsendelsesomkostninger og praktiske købsråd — samlet i ét uafhængigt ressourcehub.",
    keywords:
      "AllChinaBuy spreadsheet, AllChinaBuy anmeldelse, AllChinaBuy forsendelsesomkostninger, AllChinaBuy kupon, AllChinaBuy rabatkode",
  },
  de: {
    title: "AllChinaBuy Spreadsheet: Produkte, Verkäufer, QC & Versand-Guides",
    description:
      "Entdecken Sie AllChinaBuy-Spreadsheet-Ressourcen, Produktfindungen, Verkäufer-Guides, QC-Informationen, Versandkosten und praktische Kauftipps — gebündelt in einem unabhängigen Ressourcen-Hub.",
    keywords:
      "AllChinaBuy Spreadsheet, AllChinaBuy Test, AllChinaBuy Versandkosten, AllChinaBuy Gutschein, AllChinaBuy Rabattcode",
  },
};

export const ARTICLE_KEYWORDS =
  "AllChinaBuy spreadsheet, AllChinaBuy guide, AllChinaBuy review, AllChinaBuy shipping cost, AllChinaBuy coupon";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function setDocumentTitle(title: string) {
  if (typeof document === "undefined") return;
  document.title = title;
}

export function setMetaName(name: string, content: string) {
  upsertMeta("name", name, content);
}

export function setMetaProperty(property: string, content: string) {
  upsertMeta("property", property, content);
}

export function setCanonical(href: string) {
  upsertCanonical(href);
}